export default __webpack_public_path__ + "static/media/bike-12.968a14f5.png";